<script>
    import { WIZARD } from './context.js';
    import { getContext } from 'svelte';

    const {isFinished} = getContext(WIZARD)   
   
</script>
{#if $isFinished}
    <slot></slot>
{/if}